import React from 'react';
import { Container } from './Container';
import { CTAButton } from './CTAButton';
export function Header() {
  return <header className="border-b border-teal-soft bg-cream" data-id="element-219" data-mp="2dn5t0kfcsjhs">
      <Container className="flex h-16 items-center justify-between" data-id="element-220" data-mp="2ilqtmkyip56r">
        <a href="#inicio" className="flex items-center gap-2" aria-label="Viandas Express 15’ — inicio" data-id="element-221" data-mp="2ink5qfrwghm5">
          <img src="https://cdn.magicpatterns.com/uploads/aKo3qjHS5aFjQUFTQWQvDL/Logo-kawaii-de-viandas-express.webp" alt="" width={44} height={44} loading="eager" decoding="async" className="h-11 w-11 shrink-0 object-contain" data-id="element-222" data-mp="2ni7jbjld7rly" />
          <span className="font-heading text-lg font-extrabold tracking-tight text-teal-dark" data-id="element-223" data-mp="36as7wou17ajy">Viandas Express 15’</span>
        </a>
        <CTAButton label="Quiero acceder" location="header" size="sm" className="hidden sm:inline-flex" data-id="element-224" data-mp="3bb69bo14nm90" />
      </Container>
    </header>;
}